import type { Dispatch, SetStateAction } from 'react';
import { RecurlyError as RecurlyErrorType } from 'recurly.js';
import { FormData } from './types';

const FIELD_DISPLAY_MAP: Record<string, string> = {
  postal_code: 'zip code',
  country: 'country',
  first_name: 'first name',
  last_name: 'last name',
};

const CVV_ERROR_MESSAGES: Record<string, string> = {
  'Cvv must be three digits': 'The CVV must be three digits for this type of credit card.',
  'Cvv must be four digits': 'The CVV must be four digits for this type of credit card.',
};

export const handleRecurlyError = (
  error: RecurlyErrorType,
  handleErrors: (errors: Record<string, string>) => void,
  setFormData: Dispatch<SetStateAction<FormData>>,
) => {
  if (CVV_ERROR_MESSAGES[error.message]) {
    handleErrors({ creditCard: CVV_ERROR_MESSAGES[error.message] });
    return;
  }

  error.details?.forEach((detail) => {
    if (['number', 'month', 'year', 'cvv'].includes(detail.field)) {
      handleErrors({
        creditCard: 'Please enter valid credit card information.',
      });
    }

    if (['first_name', 'last_name', 'postal_code', 'country'].includes(detail.field)) {
      const fieldName = detail.field;
      handleErrors({
        [fieldName]:
          error.code === 'validation'
            ? 'This is a required field.'
            : `Please enter a valid ${FIELD_DISPLAY_MAP[detail.field]}.`,
      });
    }
  });

  const hasBillingError = error.details?.some((detail) =>
    ['postal_code', 'country', 'first_name', 'last_name'].includes(detail.field),
  );

  if (hasBillingError) {
    setFormData((prev: FormData) => ({
      ...prev,
      billingInfoSameAsShipping: false,
    }));
  }
};
